import { TempCheckFor } from '../enums/TempCheckFor'
import { getTextAMorPM } from './hotFoodUtils'

export const getInstructionTitle = (tempCheckFor: TempCheckFor) => {
  switch (tempCheckFor) {
    case TempCheckFor.FirstAir:
      return `${getTextAMorPM()} Turbo-serve temperature check`
    case TempCheckFor.Regular:
      return `${getTextAMorPM()} Turbo-serve temperature check`
    case TempCheckFor.CompletedAM:
      return `You’ve already completed your AM temperature check. 
        Please wait until past 12:00 to complete your PM check.`
    case TempCheckFor.CompletedToday:
      return 'You have no more checks to complete today.'
    default:
      return ''
  }
}

export const getInstructionDescription = (tempCheckFor: TempCheckFor) => {
  switch (tempCheckFor) {
    case TempCheckFor.FirstAir:
    case TempCheckFor.Regular:
      return `Air Temp checks must be completed daily AM and PM. Please record the temperature of each shelf
        using the wire air probe making sure that the probe does not touch the shelf, cabinet casing or
        product. We'll let you know if there's an issue with the recorded temperature.`
    case TempCheckFor.CompletedAM:
    case TempCheckFor.CompletedToday:
    default:
      return ''
  }
}
